<app-intermission
  *ngIf="showIntermission && !showTimer"
  [label]="intermissionButtonLabel"
  (onContinue)="stopIntermission()"
></app-intermission>

<div
  *ngIf="showTimer"
  class="app-container app-flex app-flex-middle flex-column"
>
  <div
    class="
      app-word-display
      d-flex
      flex-column
      align-items-center
      justify-content-center
    "
  >
    <p style="font-size: 500%">{{ timer }}</p>
  </div>
</div>
<div
  *ngIf="!showIntermission && !showTimer">

<div class="app-container app-flex app-flex-middle flex-column">
  <div
    class="
      app-word-display
      d-flex
      flex-column
      align-items-center
      justify-content-center
    "
    *ngIf="!finishedTrial"
  >
    <!-- image version for jspsych script version -->
    <!--
      <div class="fc_container logo-test-container" style="width: 90vw; left: 5vw">
        <div
          class="container d-flex flex-column justify-content-center align-items-center"
          style="position: relative"
        >
          <div
            class="brand-image-container d-flex justify-content-center align-items-center"
          >
            <img src=${"images/stimuli/" + image_name} style="max-height:200px">
          </div>
          <div class="row item-container" style="align-items: center; padding-bottom: 35vh">
            <div class="col">
              <div id="x_stim" class="fc_trial fc_item">${item}</div>
            </div>
          </div>
          <div id="fixed_bottom_row" class="row">
            <div class="col">
              <div id="x" class="fc_key">X</div>
              <div id="x_text" class="fc_right">${X_label}</div>
            </div>
            <div class="col">
              <div id="n" class="fc_key">N</div>
              <div id="n_text" class="fc_right">${N_label}</div>
            </div>
          </div>
        </div>
      </div>
     -->

    <!-- FIXME: image sometimes moves a few pixels based on displayed need, e.g. performance, closeness -->
    <div
      class="
        app-brand-container
        d-flex
        align-items-center
        justify-content-center
      "
      *ngIf="type === 'brand' && mode !== 'reading'"
    >
      <img
        *ngIf="brandImage"
        class="app-brand-image"
        [src]="getImagePath(brandImage)"
      />
      <div *ngIf="!brandImage" class="app-brand-name">
        {{ brandName }}
      </div>
    </div>


    <!-- ngFor is needed in order to show the fade out for every word -->
    <div class="app-word-container" *ngIf="mode !== 'reading'">
      <div
        *ngFor="let need of [stimuli[id]]"
        [@fadeOut]
        [appTriggerChoice]="mode === 'reading' ? 'reading' : type"
        (onKeypress)="nextItem($event)"
      >
        {{ stimuli[id] }}
      </div>
    </div>

    <div class="app-word-container" *ngIf="mode === 'reading'">
      <div
        *ngFor="let need of [stimuli[id]]"
        [appTriggerChoice]="mode === 'reading' ? 'reading' : type"
        (onKeypress)="nextItem($event)"
      >
        {{ stimuli[id] }}
      </div>
    </div>
  </div>

  <app-button-navigation
    [type]="type"
    [readingMode]="mode === 'reading'"
  ></app-button-navigation>
  </div>
</div>
